import styled from 'styled-components';

export const ScreenContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 100%;
  padding: 32px 42px;
  @media (max-width: 1280px) {
    padding: 30px 30px;
  }
  @media (max-width: 639px) {
    padding: 20px 10px;
  }
`;

export const BlurredContainer = styled.section`
  width: 100%;
  background: var(--blur-bg-color);
  backdrop-filter: blur(20px);
  border-radius: 2px;
  padding: 40px 50px;
  @media (max-width: 1280px) {
    padding: 20px 20px;
  }
  @media (max-width: 639px) {
    padding: 10px 10px;
  }
`;

export const BlurredContainerM2030 = styled(BlurredContainer)`
  padding: 20px 30px;
`;

export const BlurredContainerM3030 = styled(BlurredContainer)`
  padding: 30px 30px;
`;

export const MattContainer = styled.section`
  background: var(--matt-bg-color);
  padding: 20px 30px;
`;

export const MattRow = styled.div`
  background: var(--matt-bg-color);
  width: 100%;
  padding: 20px 30px;
  border-radius: 2px;
`;

export const ImageCircleBig = styled.img`
  width: 128px;
  height: 128px;
  box-shadow: 0px 0px 60px rgba(0, 0, 0, 0.6);
  object-fit: contain;
  border-radius: 64px;
  flex: none;
  @media (max-width: 1280px) {
    align-self: center;
    margin-bottom: 10px;
  }
`;
